import { render, staticRenderFns } from "./ShapeCanvas.vue?vue&type=template&id=075c37c5&scoped=true&"
import script from "./ShapeCanvas.vue?vue&type=script&lang=js&"
export * from "./ShapeCanvas.vue?vue&type=script&lang=js&"
import style0 from "./ShapeCanvas.vue?vue&type=style&index=0&id=075c37c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075c37c5",
  null
  
)

export default component.exports